/* cs-cabinet-cart.js - EX-CABINETS 2026-07-21
   The colorway page's commerce: the Flat-pack / Assembled toggle, the quantity
   steppers, and Add to cart.

   Prices and variants both come from the per-page #cwData map, which is built
   from the same records the products were created from. That is deliberate: the
   shipped preview applied a flat +$75 to EVERY card, which is wrong for trim and
   accessories (Paul's law and the product data keep those at base price in
   Assembled). Reading the map means the page cannot disagree with the store.

   Drafts: a DRAFT product's variant cannot be added to a storefront cart, so
   until Paul activates the fleet /cart/add.js answers 422. That is reported
   plainly on the button rather than failing silently. */
(function () {
  var el = document.getElementById('cwData');
  if (!el) return;
  var MAP = {};
  try { MAP = JSON.parse(el.textContent || '{}'); } catch (e) { return; }
  var mode = 'flat';

  function money(n) { return '$' + Number(n).toLocaleString('en-US') + '.00'; }

  function cardSku(node) {
    var a = node.closest('[data-code]');
    return a ? a.getAttribute('data-code') : null;
  }

  function applyMode(m) {
    mode = (m === 'assembled') ? 'assembled' : 'flat';
    document.querySelectorAll('.pdc[data-code]').forEach(function (card) {
      var rec = MAP[card.getAttribute('data-code')];
      if (!rec) return;
      var live = (mode === 'assembled') ? rec[1] : rec[0];
      var now = card.querySelector('.pdc-now');
      if (now) now.textContent = money(live);
      /* Paul's ratified rule 2026-07-30: what is shown is 35% off a marked-up retail, so
         the original is live / 0.65, rounded once. Rewritten with the live price so the
         pair cannot drift when the ship mode flips. */
      var was = card.querySelector('.pdc-was');
      if (was) was.textContent = money(Math.round(live / 0.65));
    });
    document.querySelectorAll('.cabtog-pill, .asm-pill').forEach(function (p) {
      var on = p.getAttribute('data-mode') === mode;
      p.classList.toggle('on', on);
      if (p.hasAttribute('aria-selected')) p.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var tog = document.querySelector('.cabtog');
    if (tog) tog.setAttribute('data-mode', mode);
  }

  document.addEventListener('click', function (ev) {
    var pill = ev.target.closest('.cabtog-pill, .asm-pill');
    if (pill) { applyMode(pill.getAttribute('data-mode')); return; }

    var step = ev.target.closest('.pdc-mn, .pdc-pl');
    if (step) {
      var box = step.closest('.pdc-step');
      var input = box && box.querySelector('.pdc-q');
      if (input) {
        var v = parseInt(input.value || '0', 10) || 0;
        input.value = Math.max(0, v + (step.classList.contains('pdc-pl') ? 1 : -1));
      }
      return;
    }

    var add = ev.target.closest('.pdc-add');
    if (!add || add.disabled) return;
    var sku = cardSku(add);
    var rec = MAP[sku];
    if (!rec) return;
    var card = add.closest('.pdc');
    var qInput = card && card.querySelector('.pdc-q');
    var qty = Math.max(1, parseInt((qInput && qInput.value) || '1', 10) || 1);
    var variant = (mode === 'assembled') ? rec[3] : rec[2];
    if (!variant) return;
    var label = add.textContent;
    add.disabled = true; add.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variant, quantity: qty }] })
    }).then(function (r) {
      if (r.ok) {
        add.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } else {
        add.textContent = (r.status === 422) ? 'Not yet on sale' : 'Could not add';
      }
      setTimeout(function () { add.disabled = false; add.textContent = label; }, 1800);
    }).catch(function () {
      add.textContent = 'Could not add';
      setTimeout(function () { add.disabled = false; add.textContent = label; }, 1800);
    });
  });

  window.asmSet = function (m) { applyMode(m); };
  applyMode('flat');
})();
